export enum EntertainmentTabOptions {
	ALL = 'all',
	POLITICS = 'politics',
	CURRENT = 'current',
	SPORTS = 'sports',
}
